import { FC, FunctionComponent, useContext, useMemo } from "react";
import { useController, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { TextField } from "../../../../../components/forms/text";
import { ConfigContext } from "../../../../../pages/token-onboarding/single/config-context";
import { validationFields } from "../../../../common/models/fields";
import { FieldConfigHook, FieldHook, RenderFuncProps } from "../common";

const StyledTextField = styled(TextField)`
  width: 20em;
  width: 100%;
`;

const Elem: FC<RenderFuncProps> = ({ item }: RenderFuncProps) => {
  const { t } = useTranslation("fields");
  const { config } = useContext(ConfigContext);
  const { control } = useFormContext();
  const {
    field,
    fieldState: { error },
  } = useController({
    control,
    name: item.field,
  });
  const emailDisabled = useMemo(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    return urlSearchParams.has("user");
  }, [window.location.search]);

  return config.configuration.merchantConfig.performOtp ? null : (
    <>
      <div>{t("e-mail")}</div>
      <div>
        <StyledTextField
          disabled={
            config.configuration.merchantConfig.performOtp || emailDisabled
          }
          fullWidth
          type="text"
          {...field}
          error={!!error}
          helperText={error?.message}
        />
        <em>
          <small>{t("if-you-have-already-been-screened")}</small>
        </em>
      </div>
    </>
  );
};

export const useUserEmailField: FieldHook = () => {
  const schema = validationFields.email.useSchema();
  return useMemo(
    () => ({
      schema,
      elem: Elem,
    }),
    [schema]
  );
};

const ConfigElem: FunctionComponent<{}> = () => {
  const { t } = useTranslation("fields");
  const {} = useFormContext();
  return (
    <>
      <div>{t("e-mail")}</div>
      <div>
        {/* <StyledTextField
          disabled={
            config.configuration.merchantConfig.performOtp || emailDisabled
          }
          fullWidth
          type="text"
          {...field}
          error={!!error}
          helperText={error?.message}
        /> */}
        <em>
          <small>{t("if-you-have-already-been-screened")}</small>
        </em>
      </div>
    </>
  );
};

export const useUserEmailFieldConfig: FieldConfigHook = () => {
  const schema = validationFields.email.useSchema();
  return useMemo(
    () => ({
      schema,
      elem: ConfigElem,
    }),
    [schema]
  );
};
